import {where} from "firebase/firestore";
import {contarSumaWhere} from "../../Servicios/BD/Contadores/contarSumaWhere";

export const obtenerGananciaRendimientos = async (idUsuario) => {


    let w = [where('idUsuario', '==', idUsuario), where('estado', '==', 'Aceptado'), where('tipo', '==', 'Rendimientos'), where('valor', '>', 0)];
    let dox = await contarSumaWhere({coleccion: 'movimientos', wheres: w, propiedad: 'valor'})

    if (dox.res) {
        return dox.data
    } else {
        return 0
    }


}